<template>
  <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M22.8948 22.827L19.7229 19.8756H3.83334V16.7274C3.83334 16.0903 4.00975 15.5049 4.36259 14.9712C4.71542 14.4375 5.18345 14.0297 5.76667 13.7479C6.67292 13.3169 7.59447 12.9702 8.53134 12.7079C9.4682 12.4455 10.4196 12.2487 11.3854 12.1176L0.661461 2.13895L2.38334 0.536743L24.6167 21.2248L22.8948 22.827ZM21.2333 13.7479C21.8174 14.0102 22.2806 14.4083 22.6229 14.9419C22.9653 15.4756 23.1465 16.0521 23.1667 16.6712L19.1188 12.9046C19.4813 13.0358 19.8389 13.167 20.1918 13.2981C20.5446 13.4293 20.8918 13.5792 21.2333 13.7479ZM16.1583 10.15L9.45209 3.9098C9.91528 3.27267 10.4993 2.77608 11.2042 2.42003C11.909 2.06399 12.6743 1.88597 13.5 1.88597C14.8292 1.88597 15.967 2.32634 16.9135 3.20708C17.8601 4.08782 18.3333 5.14659 18.3333 6.38338C18.3333 7.15168 18.142 7.86377 17.7594 8.51964C17.3767 9.17552 16.8431 9.71895 16.1583 10.15Z"
      fill="black"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
